import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { AibaLogo } from "../components/site/Logo";
import { ArrowLeft, ScrollText } from "lucide-react";

export default function PolicyPage({ tag, title, updated, sections, testid }) {
  return (
    <div className="relative min-h-screen bg-[#0F172A]" data-testid={testid}>
      <div className="lab-fixed-bg" aria-hidden="true" />
      <div className="relative z-10 mx-auto max-w-3xl px-6 py-20 lg:px-10">
        <div className="mb-12 flex items-center justify-between">
          <Link to="/" data-testid="policy-back" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-blue-200 transition-colors hover:text-white">
            <ArrowLeft size={14} /> {updated.back}
          </Link>
          <div className="flex items-center gap-2">
            <AibaLogo size={26} />
            <span className="font-display text-lg font-800 tracking-tighter text-white">AIBA</span>
          </div>
        </div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.35em] text-blue-400">
            <ScrollText size={14} /> [ {tag} ]
          </span>
          <h1 className="mt-4 font-display text-4xl font-800 tracking-tighter text-white sm:text-5xl">{title}</h1>
          <p className="mt-4 font-body text-sm leading-relaxed text-[#8AA0C0]">
            {updated.label} {new Date().toLocaleDateString(updated.locale)}
          </p>
        </motion.div>

        <div className="mt-14 space-y-12">
          {sections.map((s, i) => (
            <motion.section
              key={s.title}
              data-testid={`policy-section-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="rounded-2xl border border-blue-500/15 bg-blue-400/[0.02] p-7 backdrop-blur-xl"
            >
              <h2 className="font-display text-xl font-700 tracking-tight text-white">{s.title}</h2>
              <div className="mt-4 space-y-3">
                {s.body.map((p, j) => (
                  <p key={j} className="font-body text-sm leading-relaxed text-[#CBD5E1]">{p}</p>
                ))}
              </div>
              {s.bullets && s.bullets.length > 0 && (
                <ul className="mt-4 space-y-3">
                  {s.bullets.map((b, j) => (
                    <li key={j} className="flex gap-3 font-body text-sm leading-relaxed text-[#CBD5E1]">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-blue-400" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
            </motion.section>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap justify-center gap-6 border-t border-blue-500/10 pt-8">
          <Link to="/confidentialite" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060] hover:text-blue-300">{updated.privacy}</Link>
          <Link to="/cookies" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060] hover:text-blue-300">{updated.cookies}</Link>
          <Link to="/legal" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060] hover:text-blue-300">{updated.legal}</Link>
        </div>
      </div>
    </div>
  );
}
